import {
  handleResp,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type {
  WrappedCashifyFunction,
  CommonResponse,
  GenericResponse,
} from "./utils";
import type { StandardObject } from "utils";

export interface TenantInformationService {
  getTenantInformation: ReturnType<typeof getTenantInformation>;
  putTenantInformation: ReturnType<typeof putTenantInformation>;
};

// Tenant Information
export interface TenantInformationDTO {
  id: number;
  tenantId: number;
  tenantInformationData: TenantInformationDataDTO;
  revision?: number;
  lastUpdateTime?: string;
  lastUpdateAdmin?: string;
};

export interface TenantInformationData {
  platformOsVersionControl: PlatformOsVersionControl;
  maintenanceInformation: MaintenanceInformation;
  additionalData?: StandardObject;
};

export interface TenantInformationDataDTO extends TenantInformationData {
  serverTime: string;
};

export interface PlatformOsVersionCondition {
  minimumSupportedPlatformVersion?: string;
  latestPlatformVersion?: string;
  promptUpdateToLatest?: boolean;
  updateDownloadUrl?: string;
};

export interface PlatformOsVersionControl {
  android?: PlatformOsVersionCondition;
  ios?: PlatformOsVersionCondition;
};

export interface MaintenanceInformation {
  startTime?: string;
  endTime?: string;
  isInMaintenance?: boolean;
  allowTestingUser?: boolean;
  message?: string;
};

export const getTenantInformation: WrappedCashifyFunction<{}, GenericResponse<TenantInformationDTO>> = ({ urlPrefix, options }) => {
  return async () => {
    let url = `${urlPrefix}/api/v1/tenant/information`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const putTenantInformation: WrappedCashifyFunction<{ updates: TenantInformationData }, CommonResponse> = ({ urlPrefix, options }) => {
  return ({ updates }) => {
    let url = `${urlPrefix}/api/v1/tenant/information`;
    let opts = extendFetchOptions(
      {
        method: "PUT",
        headers: {
          ...getDefaultHeaders(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updates),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
